import { render, staticRenderFns } from "./QuizList.vue?vue&type=template&id=2e0e9832&"
import script from "./QuizList.vue?vue&type=script&lang=js&"
export * from "./QuizList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports